<template>
    <Transition>
        <div style="margin-right: 10px;" v-if="candidate">
        
        <div class="form container px-2">

        <h5><b>G. COMMUNITY SERVICES</b></h5>

        <!--community services-->
        <div class="mb-4 text-start">
            <div class="mb-3 d-flex align-items-center">
                <b>
                    G.1 &nbsp; &nbsp;Give details (e.g. research extension work, service on public bodies, membership of
                    socio-cultural groups, editorship of learned journals public lectures, radio or TV talks, service to
                    learned and professional bodies, publications outside main field etc.):
                </b>
                <span @click="resetEdit()" class="ms-3">
                    <button class="btn btn-outline-success" data-bs-toggle="modal" data-bs-target="#communityService"><i class="fa fa-plus" aria-hidden="true"></i></button>
                </span>
            </div>
            <ViewEditDelete @resetEdit="resetEdit" :key="key" :array=communityServices :type="'communityServices'" />
        </div>

        <!-- community services Modal -->
        <div class="modal fade" id="communityService" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="exampleModalLabel12">Community Service</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body text-start ms-3">
                        <div class="mb-3">
                            <label for="communityService" class="form-label me-3">
                                Details of Community Service</label>
                            <textarea rows="5" v-model="communityService" type="text" class="form-control"
                                id="communityService"></textarea>
                        </div>
                        <div class="mb-3 d-flex">
                            <label for="otherServiceSessionText" class="form-label">Number of sessions/years:</label>
                            &nbsp;
                            <span>
                                <input style="width: 100px" v-model="sessionNum" type="number" class="form-control"
                                    id="otherServiceSessionText">
                            </span>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button @click="joinDetails()" type="button" class="btn btn-success"
                            data-bs-dismiss="modal">Add</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="d-flex flex-row-reverse my-5">
            <button @click="saveSection('next')" type="button" class="btn btn-success">Save & Continue</button>
            <button @click="saveSection('previous')" type="button" class="btn btn-success me-3">Previous Section</button>
        </div>
    </div>
    </div>
</Transition>
</template>
<script>
import DataService from '../../services/dataservice';

export default {
    name: 'sectionG',
    emits: ['toggleLoader', 'setSection'],
    data() {
        return { 
            candidate: '',
            communityService: '',
            sessionNum: 1,
            communityServices: [],
            key: 0
        }
    },
    created() {
        this.$emit('setSection', 'Section G');
        this.setData()
    },
    methods: {
        resetEdit(){
            //removes edit section if present on the page
            for (var i=0; i < this.communityServices.length; i++) {
                this.communityServices[i].editing = false
            }
        },
        
        async saveSection(page ) {
            this.$emit('toggleLoader');
            
            var dataDetails = {
                communityServices: this.communityServices
            }

            const candidate = await DataService.saveData(dataDetails);
            
            if (candidate) {
                this.candidate = candidate;
                this.communityServices = candidate.communityServices ? candidate.communityServices : [];
                if (page == 'previous') {
                    this.$router.push('/sectionf')
                } else if (page == 'next') {
                    this.$router.push('/sectionh')
                }
            }

            this.$emit('toggleLoader');
        },
        async setData() {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            this.$emit('toggleLoader');

            const candidate = await DataService.getCandidate(JSON.parse(window.localStorage['user'])._id, 'sectionG');

            if (candidate) { 
                this.candidate = candidate;
                this.communityServices = candidate.communityServices ? candidate.communityServices : [];
            }
        
            this.$emit('toggleLoader');
        },
        joinDetails() {
            if (this.communityService) {
                this.communityServices.unshift({ data: this.communityService, sessionNum: this.sessionNum });
                this.communityService = '';
            }
            this.key += 1
        },
    }
}
</script>